import { useState, useCallback } from 'react';

interface SaveScenarioModalProps {
  onSave: (name: string, description: string) => void;
  onClose: () => void;
}

export function SaveScenarioModal({ onSave, onClose }: SaveScenarioModalProps) {
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');

  const handleSave = useCallback(() => {
    if (!name.trim()) return;
    onSave(name.trim(), desc.trim());
  }, [name, desc, onSave]);

  return (
    <div className="fixed inset-0 z-2000 flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-primary-800 rounded-lg shadow-lg border border-gray-300 dark:border-primary-500 p-4 w-80">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-primary-100 mb-3">Szenario speichern</h3>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full px-3 py-2 mb-2 text-sm bg-white dark:bg-primary-700 border border-gray-300 dark:border-primary-500 rounded-lg text-gray-800 dark:text-primary-100 focus:outline-hidden focus:ring-2 focus:ring-accent-primary"
          autoFocus
        />
        <input
          type="text"
          placeholder="Beschreibung (optional)"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
          className="w-full px-3 py-2 mb-3 text-sm bg-white dark:bg-primary-700 border border-gray-300 dark:border-primary-500 rounded-lg text-gray-800 dark:text-primary-100 focus:outline-hidden focus:ring-2 focus:ring-accent-primary"
        />
        <div className="flex gap-2 justify-end">
          <button
            onClick={onClose}
            className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-primary-400 hover:text-gray-900 dark:hover:text-primary-100 transition-colors"
          >
            Abbrechen
          </button>
          <button
            onClick={handleSave}
            disabled={!name.trim()}
            className="px-3 py-2 bg-accent-primary hover:bg-accent-primary-hover text-white border border-accent-primary rounded-lg text-sm font-medium transition-all duration-200 shadow-sm focus:outline-hidden focus:ring-2 focus:ring-accent-primary disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Speichern
          </button>
        </div>
      </div>
    </div>
  );
}
